
const Github = () => {
    window.location.replace('https://github.com/Buma78?tab=repositories');
    return null;
  
}

export default Github;